import Button from "../../../components/Button";
import ProgressBar from "../../../components/ProgressBar";
import AddIcon from "/public/images/icons/add.svg?react";
import { useNavigate } from "react-router-dom";
import { useDrawerContext } from "../../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import TextInput from "../../../components/TextInput";
import { useState } from "react";
import MedicalCard from "../../../components/MedicalCard";
import PropTypes from "prop-types";

export default function GuestBandStep3({ band }) {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const [allergies, setAllergies] = useState(localStorage.getItem("activeGuestBandStep3") ? JSON.parse(localStorage.getItem("activeGuestBandStep3")) : []);

  const openMedicalDrawer = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
          ALLERGIES
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Enter your allergy name</h3>
          <form onSubmit={addAllergies} className="flex flex-col gap-6">
            <TextInput
              key={"allergyName"}
              label={"Allergy Name"}
              name="allergyName"
            />
            <TextInput
              key={"additionalAllergy"}
              label="Additional Information"
              name="additionalInformation"
            />
            <Button submit>
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const openEditDrawer = (index) => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
          ALLERGIES
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">Edit your allergy</h3>
          <form
            onSubmit={(e) => editAllergies(e, index)}
            className="flex flex-col gap-6"
          >
            <TextInput
              key={"editAllergy" + index}
              defaultValue={allergies[index].name}
              label={"Allergy Name"}
              name="allergyName"
            />
            <TextInput
              key={"editAdditional" + index}
              defaultValue={allergies[index].additionalInformation}
              label="Additional Information"
              name="additionalInformation"
            />
            <Button submit>
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const addAllergies = (event) => {
    event.preventDefault();
    const newDetails = new FormData(event.currentTarget);

     const allergyName = newDetails.get("allergyName")?.trim();
    const additionalInformation = newDetails.get("additionalInformation")?.trim();

    if (!allergyName) {
      return;
    }

    const newMedicalDataArray = [];

    newMedicalDataArray.push({
      name: allergyName,
      additionalInformation: additionalInformation || "",
      dateAdded: new Date(),
      ongoing: false,
    });

    setAllergies([...allergies, ...newMedicalDataArray]);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const editAllergies = (event, index) => {
    event.preventDefault();

    const newAllergies = allergies.map((item, i) => {
      if (i === index) {
        item.name = event.currentTarget.allergyName.value;
        item.additionalInformation =
          event.currentTarget.additionalInformation.value;
      }
      return item;
    });
    setAllergies(newAllergies);
    setOpen(false);
  };

  const removeAllergies = (index) => {
    const newAllergies = allergies.filter((_, i) => i !== index);
    setAllergies(newAllergies);
  };

  const checkOngoing = (index) => {
    const newAllergies = allergies.map((item, i) => {
      if (i === index) {
        item.ongoing = !item.ongoing;
      }
      return item;
    });
    setAllergies(newAllergies);
  };

  const validateStep4 = () => {
    localStorage.setItem("activeGuestBandStep3", JSON.stringify(allergies));
    navigate(`/guest-bands/${band?.BandID}/activate/4`, {state: {band: band}});
  }

  return (
    <div className="w-full min-h-svh flex flex-col justify-stretch mb-[50px] bg-[#F8F8F8]">
      <div className="p-[24px] flex flex-col gap-6 bg-white">
        <ProgressBar step={3} overrideTotalSteps={4} />
        <span className="tracking-[0.25em] text-[12px] uppercase font-semibold">
          Step 3
        </span>
        <h2>Please let us know of any allergies</h2>
        <p>
          This information will be visible to venue staff and the public when your band is unlocked.
        </p>
      </div>
  
      {/* Allergy Section - Always Rendered */}
      <div className={`bg-sportsLightGrey border-[#E3E3E3] border-t-[1px] p-[24px] flex justify-center flex-col gap-6 ${allergies.length <= 1 ? 'pb-[250px]' : 'pb-[200px]'}`}>
        {allergies.length > 0 ? (
          allergies.map((item, index) => (
            <MedicalCard
              editFunc={() => openEditDrawer(index)}
              checkedFunc={() => checkOngoing(index)}
              removeFunc={() => removeAllergies(index)}
              key={index}
              medication={item}
              type="allergy"
            />
          ))
        ) : (
          <p className="text-[#909090] text-center">No allergies have been added</p>
        )}
      </div>
  
      {/* Fixed Buttons at Bottom */}
      <div className="fixed bottom-[60px] left-1/2 transform -translate-x-1/2 w-full max-w-[430px] border-t border-l border-r rounded-t-[32px] border-[#E3E3E3] bg-white p-[24px] flex flex-col justify-stretch gap-4">
        <Button className="font-semibold" onClick={openMedicalDrawer} variant="tertiary">
          <AddIcon className="w-[15px]" />
          {allergies.length > 0 ? "Add Another" : "Add Allergy"}
        </Button>
        <Button onClick={validateStep4}>
          {allergies.length > 0 ? "Confirm & Continue" : "Continue Without Allergies"}
        </Button>
      </div>
    </div>
  );
}